import { Component } from '@angular/core';
import { DepartmentsCreateComponent } from '../../../../components/admin-dashboard-component/departments-component/departments-create-component/departments-create-component';

@Component({
  selector: 'app-departments-create',
  imports: [DepartmentsCreateComponent],
  templateUrl: './departments-create.html',
  styleUrl: './departments-create.scss',
})
export class DepartmentsCreate {}
